import type { ActivitySlashCommand } from './activity-slash-command';
import { activityChatCommandRegistry } from './ActivityChatCommandRegistry';

/**
 * Регистрирует команду Activity-чата в глобальном реестре.
 * Используется в command-модулях как декларативная точка подключения команды.
 */
export function registerActivityChatCommand(command: ActivitySlashCommand): ActivitySlashCommand {
  activityChatCommandRegistry.register(command);
  return command;
}
